import { succeededAgentToolUses } from "@/lib/agent-open-file";
import type { ChatMessageDto } from "@/lib/chat";

/** バックエンド KnowledgeGraphNodeDto に対応。id は記事 ID で、そのままファイルの API の仮想ファイル ID になる。 */
export interface KnowledgeGraphNode {
	id: string;
	name: string;
	description: string;
}

/** バックエンド KnowledgeGraphLinkDto に対応。記事 ID でリンク元とリンク先を表す。 */
export interface KnowledgeGraphLink {
	source: string;
	target: string;
}

export interface KnowledgeGraph {
	nodes: KnowledgeGraphNode[];
	links: KnowledgeGraphLink[];
}

/** 記事の仮想ファイル (backend の KnowledgeArticleFiles)。環境の中に実在しないため、パスの操作を出さない。 */
export function isKnowledgeArticleFileId(fileId: string): boolean {
	return fileId.startsWith("kart_");
}

const GRAPH_CHANGING_TOOLS: ReadonlySet<string> = new Set([
	"knowledge_graph_create",
	"knowledge_graph_edit",
	"knowledge_graph_delete",
]);

/** 新しく届いた tool_result 行で、エージェントが記事の作成・編集・削除に成功したか。 */
export function agentChangedKnowledgeGraph(
	dto: ChatMessageDto,
	messages: readonly ChatMessageDto[],
): boolean {
	return succeededAgentToolUses(dto, messages).some((block) =>
		GRAPH_CHANGING_TOOLS.has(block.name),
	);
}
